/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_AInputs */

const cs_enum_a = /** @type {(inputs: Enum_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A`)
};

const en_enum_a = /** @type {(inputs: Enum_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A`)
};

/**
* | output |
* | --- |
* | "A" |
*
* @param {Enum_AInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_a = /** @type {((inputs?: Enum_AInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_AInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_a(inputs)
	return cs_enum_a(inputs)
});